import axiosInstance from '@/services/axiosInstance'

async function getSEPADebtorsByCompany (params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return null
  } else {
    const req = {
      url: 'api/SEPA/getSEPAInvoiceResume',
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getSEPADebtorsByCompany }
